import { Client, Databases, Query, Account, ID } from "appwrite";
import React, {  useMemo } from "react";
import { useSearchParams } from "react-router-dom";

const SuccessPage = () => {
  const [searchParams] = useSearchParams();
  const isLiteracy = searchParams.get("literacy") === "true";
  const customerId = searchParams.get("customer_id");
  
  const projectId = isLiteracy ? "ai-literacy" : "aireadinessdev";
  const databaseId = isLiteracy ? "ai-literacy" : "aireadinessdb";
  
  // Create Appwrite client
  const client = useMemo(() => new Client(), []);
  client
    .setEndpoint("https://api.randomwalk.ai/v1")
    .setProject(projectId);
  
  // Create Databases instance
  const databases = useMemo(() => new Databases(client), [client]);
  
  // Function to download the receipt from Appwrite
  const downloadReceipt = async () => {
    try {
      const response = await databases.listDocuments(
        databaseId,
        "test",
        [Query.equal("c_id", customerId)]
      );
      const receiptUrl = response.documents[0].receipt_url; // Assuming this is the URL for the receipt
      console.log("Receipt URL:", receiptUrl);
      return receiptUrl;
    } catch (error) {
      console.error("Error downloading receipt:", error);
    }
  }
  
  return (
    <div className="flex items-center justify-center h-screen bg-gray-100 font-display">
      <div className="bg-white p-8 md:p-12 rounded-xl shadow-xl text-center relative m-4 md:m-0 max-w-lg">
        <div id="tick-symbol" className="flex items-center justify-center w-16 h-16 bg-[#27D152] mx-auto rounded-full hover:scale-110 transition-transform duration-200 ease-in-out">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="#FFFFFF"
            className="w-8 h-8"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="5"
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>

        <h1 className="mt-6 text-2xl font-bold text-gray-900">Payment Successful!</h1>
        <p className="mt-2 text-lg font-medium text-gray-700">
          Thank you for your purchase. Your payment has been processed.
        </p>

        <div className="mt-8 space-y-4">
          {/* Download Invoice Button */}
          <button
            id="download-receipt"
            className="w-3/4 mb-4 bg-blue-500 hover:bg-blue-700 text-white font-semibold py-3 rounded-lg transition-colors duration-200"
            onClick={async () => {
              const receiptUrl = await downloadReceipt();
              if (receiptUrl) {
                window.open(receiptUrl, '_blank'); 
              }
            }}
          >
            View Receipt
          </button>

          {isLiteracy ? (
            <p className="mt-4 text-sm text-gray-600">
              A link to your <strong>AI Literacy Assessment</strong> has been sent to your registered email.
            </p>
          ) : (
            <p className="mt-4 text-sm text-gray-600">
              A link to your <strong>AI Readiness Assessment</strong> has been sent to your registered email.
            </p>
          )}
          {isLiteracy ? (
            <p className="text-sm text-gray-600 mt-4">
              Since you selected the AI Literacy version, your access is limited.{" "}
              <button id="redirecting-to-test" className="text-green-600 font-bold text-lg" onClick={() => window.open("https://ai-literacy-test.randomwalk.ai/")}>
                Click here
              </button>{" "}
              to begin your literacy journey.
            </p>
          ) : (
            <p className="text-sm text-gray-600 mt-4">
              Please check your email for the link to your AI Readiness Assessment. 
            </p>
          )}

        </div>
      </div>
    </div>
  );
};

export default SuccessPage;